
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestArticles from './components/LatestArticles';
import TrustSection from './components/TrustSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <LatestArticles />
      <TrustSection />
      <Footer />
    </div>
  );
};

export default Home;
